// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-notification[data-v-4d524046] {
  width: 310px;
  height: 85px;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 10px;
  color: var(--main-body-color);
  background-color: var(--bg-color);
  /*top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;*/
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
}
.system-notification .close-btn[data-v-4d524046] {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 10px;
  transform: translate(10px, -10px);
  cursor: pointer;
  color: #D1D1D1;
}
.system-notification .close-btn[data-v-4d524046]:hover {
  color: #7F7F7F;
}
.system-notification .icon[data-v-4d524046] {
  height: 65px;
  width: 65px;
  border-radius: 50%;
  background-color: var(--elem-red-color);
  color: white;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
}
.system-notification .info[data-v-4d524046] {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 15px;
  height: 55%;
  font-size: 14px;
}
.system-notification .info div[data-v-4d524046] {
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 180px;
  overflow: hidden;
}
.system-notification .info .title[data-v-4d524046] {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/notification/SystemNotification.vue"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,iCAAiC;EACjC;;;;kBAIgB;EAChB,uDAAuD;EACvD,oDAAoD;EACpD,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".system-notification[data-v-4d524046] {\n  width: 310px;\n  height: 85px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  border-radius: 10px;\n  color: var(--main-body-color);\n  background-color: var(--bg-color);\n  /*top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;*/\n  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);\n  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);\n}\n.system-notification .close-btn[data-v-4d524046] {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  padding: 10px;\n  transform: translate(10px, -10px);\n  cursor: pointer;\n  color: #D1D1D1;\n}\n.system-notification .close-btn[data-v-4d524046]:hover {\n  color: #7F7F7F;\n}\n.system-notification .icon[data-v-4d524046] {\n  height: 65px;\n  width: 65px;\n  border-radius: 50%;\n  background-color: var(--elem-red-color);\n  color: white;\n  margin-left: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n}\n.system-notification .info[data-v-4d524046] {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  margin-left: 15px;\n  height: 55%;\n  font-size: 14px;\n}\n.system-notification .info div[data-v-4d524046] {\n  font-size: 14px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 180px;\n  overflow: hidden;\n}\n.system-notification .info .title[data-v-4d524046] {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
